import React from 'react';
import LocationDetailsForm from './LocationDetailsForm';

class LocationDetails extends React.Component {
  static displayName = 'LocationDetails';

  constructor(props) {
    super(props);
    this.state = {
      isArchiving: false,
      isSaving: false,
      errorMsg: undefined,
      successMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  handleSubmit = values => {
    this.setState({ isSaving: true, errorMsg: undefined });
    // Don't send Role to the API
    delete values.organisationTypeId;

    const customerId = parseInt(this.props.params.customerId, 10);

    if (values.id) {
      this.props
        .updateCurrentCustomerLocation(values, customerId)
        .then(
          response => this.success(response, customerId, false),
          error => this.failure(error)
        );
    } else {
      this.props
        .addCurrentCustomerLocation(values, customerId)
        .then(
          response => this.success(response, customerId, true),
          error => this.failure(error)
        );
    }
  };

  success = (response, customerId, redirect = false) => {
    if (response.status < 400) {
      this.setState({
        isSaving: false,
        errorMsg: undefined,
        successMsg: 'Success!'
      });
      this.timeoutId = setTimeout(
        () => this.setState({ successMsg: undefined }),
        3000
      );

      if (redirect) {
        const newLocationId = response.data.id;
        this.props.router.push(
          `/customer/${customerId}/sub-accounts/${newLocationId}`
        );
      }
    } else {
      this.failure(response);
    }
  };

  failure = error => {
    this.setState({
      isSaving: false,
      isArchiving: false,
      errorMsg: error.data.message
    });
  };

  archiveUser = values => {
    this.setState({ isArchiving: true });
    const updatedValues = { ...values, isArchived: !values.isArchived };
    this.props.updateUser(updatedValues).then(
      response => {
        if (response.status < 400) {
          this.setState({ isArchiving: false, errorMsg: undefined });
        } else {
          this.failure(response);
        }
      },
      error => this.failure(error)
    );
  };

  render() {
    const { currentCustomer, params } = this.props;

    return (
      <LocationDetailsForm
        onSubmit={this.handleSubmit}
        initialValues={currentCustomer.currentLocation}
        enableReinitialize={true}
        currentCustomer={currentCustomer}
        currentLocation={currentCustomer.currentLocation}
        isSaving={this.state.isSaving}
        isArchiving={this.state.isArchiving}
        errorMsg={this.state.errorMsg}
        successMsg={this.state.successMsg}
        isNew={params.locationId === 'new'}
      />
    );
  }
}

export default LocationDetails;



// WEBPACK FOOTER //
// ./src/containers/location/LocationDetails.js